import React from 'react';
import { styled } from '@components-shared/src/stitches';
import type { ButtonProps } from '../button/Button';
import { Button } from '../button/Button';

export const StandardModalButton = (props: ButtonProps & { isNotModalSmall?: boolean }) => {
  return <ModalButton {...props} fullWidthAnchor={!!props.href} />;
};

const ModalButton = styled(Button, {
  height: 44,
  width: '100%',
  maxWidth: 'unset',
  fontSize: '14px !important',

  '@tablet': {
    fontSize: '16px !important',
  },

  variants: {
    isNotModalSmall: {
      true: {
        width: 'initial',
        maxWidth: 'initial',
      },
    },
  },
});
